import { useEffect, useState } from 'react';
import { Segment, Header, Pagination, Dropdown, Icon } from 'semantic-ui-react';

import { linktreesOrderBy } from '../../config/config';
import { useTranslation } from 'react-i18next';
import LinktreeListViewItem from './linktreeListViewItem';

const LinktreeListView = ({show, pagination, onClickEdit, onChangeOrderBy, onSetPagination, list, orderBy}) => {
  const {t} = useTranslation()
  const [data, setData] = useState();

  useEffect(() => {
    setData(list);
  }, [list]);
  
  if(!show)
    return null

  return(
    <section>
      <Header as='h2' attached='top' className={'background-blue'} style={{display: 'flex'}}>
        <Pagination
          activePage={pagination.activePage}
          onPageChange={onSetPagination}
          firstItem={null}
          lastItem={null} 
          pointing
          secondary
          inverted
          style={{borderColor: 'transparent'}}
          totalPages={pagination.totalPages}
        />
        <Dropdown 
          text={t('input-label-sortby', {sortby: t(`label-${orderBy}`)})}
          style={{marginRight: 0, marginLeft: 'auto'}}
        >
          <Dropdown.Menu>
            {linktreesOrderBy.map(element => (
              <Dropdown.Item key={element.key} value={element.value} text={t(element.text)} onClick={onChangeOrderBy}/>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Header>
      <Segment attached >
        {data && data.length > 0 ? data.map((element, index) => (
          <LinktreeListViewItem
            id={element.id}
            title={element.title}
            slug={element.slug}
            type={element.type}
            isActive={element.isActive}
            updatedAt={element.updatedAt}
            createdAt={element.createdAt}
            onClickEdit={onClickEdit}
          />
        )) :
          <Header as='h2' icon textAlign='center'>
            <Icon name='sticky note outline' color='blue' circular inverted />
            {t('headline-no_linktrees')}
            <Header.Subheader>
              {t('content-no_linktrees')}
            </Header.Subheader>
          </Header>
        }
      </Segment>
    </section>
  )
}

export default LinktreeListView
